<template>
  <div id="work-in-progress-page" v-if="!loading">
    <div class="flex-grow my-4">
      <h1>{{ $t('Renewals') }}</h1>
    </div>
    <div class="vx-card">
      <grid-panel
          :column-defs="renewalColumnDefs"
          :url="renewalUrl"
          :apiParams="apiParams"
          :gridOptions="gridOptionsRenewal"
          :defaultColDef="defaultColDef"
          :headerTextWrap="true"
      >
        <template slot="right">
          <date-range-picker class="ml-4" @update:startDate="startDate = $event" @update:endDate="endDate = $event" />
        </template>
      </grid-panel>
    </div>
  </div>
</template>

<script>
  import GridPanel from '@/views/components/ag-grid/GridPanel';
  import GridActionsMenu from "../../components/extra-components/GridActionsMenu";
  import RenewalsConfig from "../../../grids/Renewals/RenewalsConfig";
  import DateRangePicker from "../../components/calendar/DateRangePicker";
  import CellRendererDate from "../../components/ag-grid/cell-renderer/CellRendererDate";
  import CellRendererAction from "../../components/ag-grid/cell-renderer/CellRendererAction";
  import CellRendererCurrency from "../../components/ag-grid/cell-renderer/CellRendererCurrency";
  import CellRendererButton from '@/views/components/ag-grid/cell-renderer/CellRendererButton';
  import SetGridOptionsMixin from "@/components/mixins/SetGridOptionsMixin";
  import ToolTipRenderer from '@/views/components/ag-grid/components/ToolTipRenderer';
  import CellRendererMasterValue from "../../components/ag-grid/cell-renderer/CellRendererMasterValue";
  import {
    TABLE_IDENTIFIER_FW_RENEWAL_ID,
  } from '@/constants'
  import moment from 'moment';

  export default {
    components: {
      GridPanel,
      GridActionsMenu,
      DateRangePicker,
      CellRendererDate,
      CellRendererAction,
      CellRendererCurrency,
      ToolTipRenderer,
      CellRendererButton,
      CellRendererMasterValue,
    },
    mixins: [SetGridOptionsMixin],
    data() {
      return {
        renewalUrl: (params) => this.$api.renewal.list(params),
        startDate: null,
        endDate: null,
        gridOptionsRenewal: {},
        defaultColDef: {
          minWidth: 100,
          resizable: true,
          sortable: true,
          wrapText: true,
          tooltipComponent: 'ToolTipRenderer',
        },
        loading: true,
        renewalColumnDefs: [],
      };
    },
    computed: {
      apiParams() {
        // Only set these when we have the full date range available
        // Otherwise it loads the endpoint twice and fails the first time due to missing parameters
        if (!this.startDate || !this.endDate) {
          return null;
        }

        return {
          startDate: (this.startDate) ? moment(this.startDate).format('YYYY-MM-DD') : null,
          endDate: (this.endDate) ? moment(this.endDate).format('YYYY-MM-DD') : null
        }
      },
    },
    methods: {
      async setColumnDefs() {
        this.loading = true;
        const renewalWidthsConfig = await this.setGridWidthOptions(TABLE_IDENTIFIER_FW_RENEWAL_ID);
        this.setRenewalColumnDefs(renewalWidthsConfig);

        this.loading = false;
      },
      setRenewalColumnDefs(renewalWidthsConfig) {
        this.renewalColumnDefs = this.getColumnDefsWithWidths(RenewalsConfig, renewalWidthsConfig);
      },
    },
    async created() {
      await this.setColumnDefs();
    },
  };
</script>
